import _Runfest from './Runfest'
import ConfigureEpicsInternal from './ConfigureEpicsInternal'

export const Runfest = _Runfest
export const EpicRunfest = _Runfest

export const registerEpic = ConfigureEpicsInternal.registerEpic
